export default "__VITE_ASSET__DJdQCzQu__"